import BusinessSuiteContentLayout from "layout/business-suite-content/BusinessSuiteContentLayout";
import { useAppSelector } from "store/store";
import { Carousel, CarouselContent, CarouselItem } from "components/ui/carousel";
import { noneProfile, profileVerified, restaurantMenu, statisticDashboard } from "assets";
import ImageUrl from "components/app/image-url/ImageUrl";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { RequestApi, RouteApi, RouteUrl, StatusMsg } from "utils";
import { useDispatch } from "react-redux";
import { setCategories, setRequestWorkflows, setUserShopPositions, setUserShopProfile } from "store/businessSuiteSlice";
import { AppLog } from "services";
import ImageUrlCoverProfile from "components/app/image-url/ImageUrlCoverProfile";
import { CalendarClock, CircleAlert, Eye, Loader, Settings, X } from "lucide-react";
import QrCodeGenerater from "components/app/qr-code-generater/QrCodeGenerater";
import ShopDetailUploadProfile from "components/app/upload-profile/ShopDetailUploadProfile";
import QrCodeGeneraterMenu from "components/app/qr-code-generater/QrCodeGeneraterMenu";
import { DialogHeader, Dialog, DialogContent, DialogTrigger, DialogFooter, DialogTitle, DialogDescription } from "components/app/dialog/dialog";
import InputHideShow from "components/app/function/InputHideShow";
import { AlertDialogCom } from "components/app/alert-dialog/AlertDialogCom";
import { Button } from "components/ui/button";
import DialogUserPermissions from "./profile-detail/DialogUserPermissions";
import { Card } from "components/ui/card";
import { Separator } from "components/ui/separator";
import GoogleMapPreview from "components/app/google-map/GoogleMapPreview";
import useClipboard from "react-use-clipboard";
import DialogFlipFlopPage from "./profile-detail/DialogFlipFlopPage";
import DailogEditShopDetail from "./profile-detail/DailogEditShopDetail";
import UploadShopCoverProfile from "components/app/upload-cover-profile/UploadShopCoverProfile";
import DialogClickShopProfilePicture from "./profile-detail/dialog-click-shop-profile-picture/DialogClickShopProfilePicture";
import DialogClickShopCoverProfile from "./profile-detail/dialog-click-shop-cover-profile/DialogClickShopCoverProfile";
import QrCodeTimesheetGenerater from "components/app/qr-code-generater/QrCodeTimesheetGenerater";

export default function BusinessSuite() {
  const { userShopProfile } = useAppSelector((state) => state.businessSuite);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const [loadingShops, setLoadingShops] = useState<boolean>(false);
  const { token, userAuth } = useAppSelector((state) => state.auth);
  const [inputPassword, setInputPassword] = useState<string>("");
  const [validateText, setValidateText] = useState<string>("");
  const [isDialogUpdatePageStatusDelete, setIsDialogUpdatePageStatusDelete] = useState<boolean>(false);
  const [isDialogUpdatePageStatus, setIsDialogUpdatePageStatus] = useState<boolean>(false);
  const [isDialogChangePassword, setIsDialogChangePassword] = useState<boolean>(false);
  const [loadingUpdatePageStatus, setLoadingUpdatePageStatus] = useState<boolean>(false);
  const [isDialogOpenFlipFlopPage, setisDialogOpenFlipFlopPage] = useState<boolean>(false);
  const [isDialogClickOpenCoverProfile, setIsDialogClickOpenCoverProfile] = useState<boolean>(false);
  const [itemCoverProfile, setItemCoverProfile] = useState<any>();
  const [userAllCoverProfiles, setUserAllCoverProfiles] = useState<any>();

  const [isDialogClickOpenShopProfilePicture, setIsDialogClickOpenShopProfilePicture] = useState<boolean>(false);
  const linkUrlClipboard = `${process.env.REACT_APP_URL}/profile?id=
      ${userShopProfile?.id}`;

  const [isCopied, setCopied] = useClipboard(linkUrlClipboard, {
    successDuration: 1000,
  });
  const [errorStatus, setErrorStatus] = useState({
    title: "",
    message: "",
  });
  const [warning, setWarning] = useState(false);
  const fetchGetUserShopProfile = async () => {
    try {
      setLoadingShops(true);
      let url: string = "";
      url = RouteApi.getAccountShopDetail;
      url += `token=${token}`;

      const data = {
        shop_id: shopId,
      };

      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        dispatch(setUserShopProfile(response["user_shop"]));
        dispatch(setCategories(response["categories"]));
        dispatch(setRequestWorkflows(response["request_workflows"]));
        dispatch(setUserShopPositions(response["user_shop_positions"]));
      } else {
        setErrorStatus({
          title: response.status,
          message: response.msg,
        });
        setWarning(true);
        AppLog.show({ message: response.msg, status: StatusMsg.getType(response.status) });
      }
    } catch (error) {
      AppLog.show({
        message: `[fetchGetUserShopProfile]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingShops(false);
    }
  };

  const onSubmitPublishedToUnpublish = async () => {
    try {
      setLoadingShops(true);
      let url: string = "";
      url = RouteApi.submitUnpublishShopInformation;
      url += `token=${token}`;

      const data = {
        shop_id: shopId,
        password: inputPassword,
      };

      const response = await RequestApi(url, { data });

      if (response.status === "success") {
        const updateUserShop = {
          ...userShopProfile,
          status: response.user_shop.status, // Corrected the syntax
        };
        dispatch(setUserShopProfile(updateUserShop));
        setIsDialogUpdatePageStatus(false);
      } else {
        setValidateText(response.msg);
      }
    } catch (error) {
      AppLog.show({
        message: `[onSubmitPublishedToUnpublish]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingShops(false);
    }
  };

  const onSubmitUnpublishToPublished = async () => {
    try {
      setLoadingShops(true);
      let url: string = "";
      url = RouteApi.submitSendReviewShopInformation;
      url += `token=${token}`;

      const data = {
        shop_id: shopId,
        password: inputPassword,
      };

      const response = await RequestApi(url, { data });

      if (response.status === "success") {
        const updateUserShop = {
          ...userShopProfile,
          status: response.user_shop.status,
        };
        dispatch(setUserShopProfile(updateUserShop));
        setIsDialogUpdatePageStatus(false);
      } else {
        setValidateText(response.msg);
      }
    } catch (error) {
      AppLog.show({
        message: `[onSubmitUnpublishToPublished]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingShops(false);
    }
  };

  const onSubmitDeletePage = async () => {
    try {
      setLoadingUpdatePageStatus(true);
      let url: string = "";
      url = RouteApi.submitDeleteShopInformation;
      url += `token=${token}`;

      const data = {
        page_id: userAuth.id,
        password: inputPassword,
      };

      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        const updateUserShop = {
          ...userShopProfile,
          status: response.user_shop.status,
        };
        dispatch(setUserShopProfile(updateUserShop));
        setIsDialogUpdatePageStatus(false);
      } else {
        setValidateText(response.msg);
      }
    } catch (error) {
      AppLog.show({
        message: `[onSubmitDeletePage]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingUpdatePageStatus(false);
    }
  };

  const submitDeleteShopProfileCover = async (item: any) => {
    // setLoadingItemEducationId(item.id); // Reset loading state
    try {
      const url = `${RouteApi.submitDeleteShopCover}token=${token}`;
      const data = {
        id: item.id,
        shop_id: shopId,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        const updateUser = {
          ...userShopProfile,
        };
        updateUser.user_shop_cover_pictures = response.user_shop_cover_pictures;
        dispatch(setUserShopProfile(updateUser));
        setUserAllCoverProfiles(response.user_shop_cover_pictures);
      }
    } catch (error) {
      AppLog.show({
        message: `[submitDeleteShopProfileCover]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      // setLoadingItemEducationId(null); // Reset loading state
    }
  };

  useEffect(() => {
    if (shopId) {
      fetchGetUserShopProfile();
    }
  }, [shopId]);

  return (
    <BusinessSuiteContentLayout>
      {warning ? (
        <div className="flex flex-col gap-2 items-center justify-center h-[70vh] w-full  ">
          <CircleAlert className="text-yellow-500 mx-auto w-[200px] h-[200px]" />
          <h1
            className={`text-[30px] font-semibold   ${
              errorStatus?.title === "success" || errorStatus?.title === "info" ? "text-green-500" : errorStatus?.title === "warning" ? "text-yellow-500" : "text-red-500"
            }`}
          >
            {errorStatus?.title === "success" ? "Success" : errorStatus?.title === "info" ? "Infomation" : errorStatus?.title === "warning" ? "Warning" : "Error"}
          </h1>
          <span className=" text-muted-foreground text-md pt-3 ">{errorStatus?.message}</span>
        </div>
      ) : (
        <>
          {userShopProfile ? (
            <div className="min-h-[calc(100vh-120px)] w-full flex justify-center">
              <Card className="w-[400px] md:w-[600px] lg:w-[715px] mb-8">
                {/* CoverUserProfile */}
                <div className="">
                  <div className="relative flex justify-center w-full h-[200px] sm:h-[300px] md:h-[400px]">
                    <Carousel className="h-full border-none">
                      <CarouselContent className="w-full h-[200px] sm:h-[300px] md:h-[400px] border-none rounded-t-lg aspect-[16/9] bg-white">
                        {userShopProfile.user_shop_cover_pictures?.length > 0 ? (
                          <>
                            {userShopProfile.user_shop_cover_pictures.map((coverPicture: any, coverIndex: number) => {
                              return (
                                <CarouselItem
                                  key={coverIndex}
                                  className="rounded-3xl cursor-grab h-[200px] sm:h-[300px] md:h-[400px]"
                                  onClick={() => {
                                    setIsDialogClickOpenCoverProfile(true);
                                    setItemCoverProfile(coverPicture);
                                    setUserAllCoverProfiles(userShopProfile?.user_shop_cover_pictures);
                                  }}
                                >
                                  <ImageUrlCoverProfile
                                    src={coverPicture.picture}
                                    className="w-full h-[200px] sm:h-[300px] md:h-[400px] object-cover rounded-t-lg aspect-[9/16]"
                                    alt="cover"
                                  />
                                </CarouselItem>
                              );
                            })}
                          </>
                        ) : (
                          <CarouselItem className="rounded-3xl">
                            <img src={noneProfile} className="w-full h-[200px] sm:h-[300px] md:h-[400px] object-cover rounded-3xl aspect-[9/16]" alt="cover" />
                          </CarouselItem>
                        )}
                      </CarouselContent>
                    </Carousel>

                    <button className="absolute bottom-4 right-6 border p-2 rounded-full bg-gray-200 dark:bg-accent dark:hover:bg-slate-900">
                      <UploadShopCoverProfile
                        user={userShopProfile}
                        onUploadSuccess={(valueSuccess: any) => {
                          const tmpUserShopProfile = { ...userShopProfile };
                          tmpUserShopProfile.user_shop_cover_pictures = valueSuccess.user_shop_cover_pictures;
                          dispatch(setUserShopProfile(tmpUserShopProfile));
                        }}
                      />
                    </button>
                  </div>

                  {/* UserProfile */}
                  <div className="relative flex justify-start">
                    <div className="absolute -top-16 left-8 flex flex-col text-center">
                      <div className="relative">
                        <div
                          className="cursor-pointer"
                          onClick={() => {
                            setIsDialogClickOpenShopProfilePicture(true);
                          }}
                        >
                          <ImageUrl src={userShopProfile.picture} className="rounded-full w-[140px] h-[140px] border-4" />
                        </div>
                        <button className="absolute bottom-2 right-1 mt-1 rounded-full z-20 bg-gray-200 dark:bg-accent dark:hover:bg-slate-900">
                          <ShopDetailUploadProfile
                            onUploadSuccess={(valueSuccess: any) => {
                              const updateData = {
                                ...userShopProfile,
                                picture: valueSuccess.picture,
                              };
                              dispatch(setUserShopProfile(updateData));
                            }}
                            userShop={userShopProfile}
                          />
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-end me-4 space-x-2 mt-2">
                    <div className="p-1 bg-gray-200 dark:bg-accent dark:hover:bg-slate-900 w-9 h-9 rounded-full border cursor-pointer">
                      <img
                        onClick={() => navigate(`/dashboard?id=${shopId}`)}
                        src={statisticDashboard}
                        alt="icon"
                        className="filter invert-0 brightness-100 dark:invert dark:brightness-0"
                      />
                    </div>

                    <div className="p-1 bg-gray-200 dark:bg-accent dark:hover:bg-slate-900 w-9 h-9 rounded-full border cursor-pointer">
                      <QrCodeTimesheetGenerater
                        linkUrl={`${process.env.REACT_APP_ESS_URL}${RouteUrl.shopClockTime}?id=${userShopProfile.shop_id}`}
                        userShop={userShopProfile}
                        logoIcon={<CalendarClock className="filter invert-0 brightness-100 dark:invert dark:brightness-0" />}
                      />
                    </div>

                    <div className="p-1 bg-gray-200 dark:bg-accent dark:hover:bg-slate-900 w-9 h-9 rounded-full border cursor-pointer">
                      <QrCodeGeneraterMenu
                        userShop={userShopProfile}
                        linkUrl={`${process.env.REACT_APP_FFP_URL}${RouteUrl.shopMenu}?id=${userShopProfile.shop_id}`}
                        logoIcon={<img src={restaurantMenu} alt="icon" className="filter invert-0 brightness-100 dark:invert dark:brightness-0" />}
                      />
                    </div>

                    <QrCodeGenerater
                      user={userAuth}
                      linkUrl={`${process.env.REACT_APP_FFP_URL}/profile?id=${userAuth?.id}`}
                      linkUrlClipboard={`${process.env.REACT_APP_FFP_URL}/@${userAuth?.username}`}
                      className="p-1 bg-gray-200 dark:bg-accent dark:hover:bg-slate-900  w-9 h-9 rounded-full border cursor-pointer"
                    />

                    <DailogEditShopDetail
                      onValueChange={(value) => {
                        const updateData = {
                          ...userShopProfile,
                          ...value,
                        };
                        dispatch(setUserShopProfile(updateData));
                      }}
                      userUpdateProfileInformation={userShopProfile}
                    />

                    <Dialog>
                      <DialogTrigger asChild>
                        <Settings className="p-1 bg-gray-200 dark:bg-accent dark:hover:bg-slate-900 w-9 h-9 rounded-full border cursor-pointer" />
                      </DialogTrigger>
                      <DialogContent isShowBtnXClose={true} className="custom-dialog-class">
                        <DialogHeader>
                          <DialogTitle>Shop Setting</DialogTitle>
                          <DialogDescription>The Shop Settings section allows you to manage the visibility, access, and status of your shops.</DialogDescription>
                        </DialogHeader>
                        <div className="flex flex-col space-y-2">
                          {userShopProfile?.status === "Unpublished" && (
                            <Dialog open={isDialogUpdatePageStatus}>
                              <DialogTrigger
                                asChild
                                onClick={() => {
                                  if (userShopProfile.provider_set_password === "No") {
                                    setIsDialogChangePassword(true);
                                  } else {
                                    setInputPassword("");
                                    setValidateText("");
                                    setIsDialogUpdatePageStatus(true);
                                  }
                                }}
                                className="rounded-lg p-2 w-full bg-sky-600 hover:bg-sky-500 flex items-center justify-center"
                              >
                                <button className="font-semibold text-xs text-white">Publish</button>
                              </DialogTrigger>

                              <DialogContent isShowBtnXClose={false} className="sm:max-w-md">
                                <DialogHeader>
                                  <DialogTitle>Publish Shop</DialogTitle>
                                  <DialogDescription>You are sending your shop informatin to our review team, the review process will take 24 hours!</DialogDescription>
                                  <div
                                    className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
                                    onClick={() => setIsDialogUpdatePageStatus(false)}
                                  >
                                    <X />
                                  </div>
                                </DialogHeader>
                                <div>
                                  <p>Please input your password for confirmation</p>
                                  <div className="mt-2">
                                    <InputHideShow onChange={(event) => setInputPassword(event.target.value)} placeholder="Password" />
                                    <span className="text-sm text-destructive">{validateText}</span>
                                  </div>
                                </div>
                                <DialogFooter className="sm:justify-end">
                                  <AlertDialogCom
                                    alertTitle="Confirmation"
                                    handleSubmit={() => onSubmitUnpublishToPublished()}
                                    nameSubmitButton="Ok"
                                    alertDescription="Do you want to continue?"
                                  >
                                    <Button className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-4 py-2 rounded-xl shadow-md hover:scale-105 hover:shadow-lg transition-all duration-300">
                                      {loadingUpdatePageStatus ? <Loader className="animate-spin w-5 h-5" /> : "Continue"}
                                    </Button>
                                  </AlertDialogCom>
                                </DialogFooter>
                              </DialogContent>
                            </Dialog>
                          )}

                          {["In Review", "Actived"].includes(userShopProfile.status) && (
                            <Dialog open={isDialogUpdatePageStatus}>
                              <DialogTrigger
                                onClick={() => {
                                  setInputPassword("");
                                  setValidateText("");
                                  setIsDialogUpdatePageStatus(true);
                                }}
                                asChild
                                className="rounded-lg p-2 w-full bg-destructive hover:bg-red-600 flex items-center justify-center"
                              >
                                <button className="font-semibold text-xs text-white">Unpublished</button>
                              </DialogTrigger>
                              <DialogContent isShowBtnXClose={false} className="sm:max-w-md">
                                <DialogHeader>
                                  <DialogTitle>Unpublished Shop</DialogTitle>
                                  <DialogDescription>
                                    This shop is currently published and visible to userShopProfiles. If you want to unpublish your shop, you can click on 'Unpublished'.
                                  </DialogDescription>
                                  <div
                                    className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
                                    onClick={() => setIsDialogUpdatePageStatus(false)}
                                  >
                                    <X />
                                  </div>
                                </DialogHeader>
                                <div>
                                  <p>Please input your password for confirmation</p>
                                  <div className="mt-2">
                                    <InputHideShow onChange={(event) => setInputPassword(event.target.value)} placeholder="Password" />
                                    <span className="text-sm text-destructive">{validateText}</span>
                                  </div>
                                </div>
                                <DialogFooter className="sm:justify-end">
                                  <AlertDialogCom
                                    alertTitle="Confirmation"
                                    handleSubmit={() => onSubmitPublishedToUnpublish()}
                                    nameSubmitButton="Ok"
                                    alertDescription="Do you want to continue?"
                                  >
                                    <Button className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-4 py-2 rounded-xl shadow-md hover:scale-105 hover:shadow-lg transition-all duration-300">
                                      {loadingUpdatePageStatus ? <Loader className="animate-spin w-5 h-5" /> : "Continue"}
                                    </Button>
                                  </AlertDialogCom>
                                </DialogFooter>
                              </DialogContent>
                            </Dialog>
                          )}

                          {userShopProfile?.status === "Unpublished" && (
                            <Dialog open={isDialogUpdatePageStatusDelete}>
                              <DialogTrigger
                                onClick={() => {
                                  setInputPassword("");
                                  setValidateText("");
                                  setIsDialogUpdatePageStatusDelete(true);
                                }}
                                asChild
                                className="rounded-lg p-2 w-full bg-red-500 hover:bg-red-400 flex items-center justify-center"
                              >
                                <button className="font-semibold text-xs text-white">Delete Shop</button>
                              </DialogTrigger>

                              <DialogContent isShowBtnXClose={false} className="sm:max-w-md">
                                <DialogHeader>
                                  <DialogTitle>Delete Shop</DialogTitle>
                                  <DialogDescription>
                                    You are deleting your shop information, you have only 30 days to recover you shop back, otherwise, your shop data will be deleted!
                                  </DialogDescription>
                                  <div
                                    className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
                                    onClick={() => setIsDialogUpdatePageStatusDelete(false)}
                                  >
                                    <X />
                                  </div>
                                </DialogHeader>
                                <div>
                                  <p>Please input your password for confirmation</p>
                                  <div className="mt-2">
                                    <InputHideShow onChange={(event) => setInputPassword(event.target.value)} placeholder="Password" />
                                    <span className="text-sm text-destructive">{validateText}</span>
                                  </div>
                                </div>
                                <DialogFooter className="sm:justify-end">
                                  <AlertDialogCom
                                    alertTitle="Are you sure?"
                                    alertDescription="This action cannot be undone. Are you sure you want to proceed?"
                                    handleSubmit={onSubmitDeletePage}
                                    nameSubmitButton="Confirm"
                                    loading={loadingUpdatePageStatus}
                                  >
                                    <Button className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-4 py-2 rounded-xl shadow-md hover:scale-105 hover:shadow-lg transition-all duration-300">
                                      {loadingUpdatePageStatus ? <Loader className="animate-spin w-5 h-5" /> : "Continue"}
                                    </Button>
                                  </AlertDialogCom>
                                </DialogFooter>
                              </DialogContent>
                            </Dialog>
                          )}

                          {/* User Permissions */}
                          <DialogUserPermissions user={userShopProfile} />
                        </div>
                      </DialogContent>
                    </Dialog>
                  </div>
                </div>

                {/* Profile Infomation */}
                <div className="px-4 space-y-3 mt-14">
                  <div>
                    {/* Name & Bio */}
                    <div className="text-start space-y-2 mb-3">
                      <div className=" flex justify-start">
                        <div className="flex items-center">
                          <p className="text-lg lg:text-xl font-bold line-clamp-1">{userShopProfile?.shop_name}</p>
                        </div>
                        {userShopProfile?.is_verified === "Yes" ? (
                          <>
                            <div className="flex items-center justify-center pt-0.5 ml-1">
                              <img src={profileVerified} style={{ width: 24, height: 24 }} alt="" />
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>

                      <h1 className="text-md lg:text-md font-semibold line-clamp-2 text-muted-foreground">{userShopProfile?.description}</h1>
                    </div>

                    <div>
                      <Separator className="my-4" />
                      <h1 className="text-lg font-bold">Group</h1>
                      <div className="flex items-center space-x-3 mt-1 mb-3">
                        {userShopProfile?.shop_group ? (
                          <>
                            <p className="text-sm font-semibold">{userShopProfile?.shop_group}</p>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>

                    <div>
                      <Separator className="my-4" />
                      <h1 className="text-lg font-bold">Category</h1>
                      <div className="flex items-center space-x-3 mt-1 mb-3">
                        {userShopProfile?.shop_category ? (
                          <>
                            <p className="text-sm font-semibold">{userShopProfile?.shop_category}</p>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>

                    <div className="">
                      <h1 className="text-lg font-bold">FlipFlop Page</h1>
                      <div
                        onClick={() => setisDialogOpenFlipFlopPage(true)}
                        className="flex p-1 rounded-lg items-center mt-1 cursor-pointer bg-slate-50 hover:bg-slate-100 dark:bg-background dark:hover:bg-slate-900"
                      >
                        <ImageUrl src={userShopProfile?.page_data?.thumbnail} className="w-8 h-8 rounded-full border" />
                        <div className="flex flex-col justify-center items-start ml-2">
                          <div className="flex items-center justify-between">
                            <h4 className="font-medium line-clamp-1">
                              {userShopProfile?.page_data?.shop_name}
                              {userShopProfile?.page_data?.name}
                            </h4>
                            {userAuth?.is_verified === "Yes" ? (
                              <>
                                <img
                                  src={profileVerified}
                                  alt=""
                                  className="ml-1"
                                  style={{
                                    width: 16,
                                    height: 16,
                                  }}
                                />
                              </>
                            ) : (
                              <></>
                            )}
                          </div>
                          <h5 className="text-muted-foreground text-xs line-clamp-1">
                            {userShopProfile?.page_data?.shop_category}
                            {userShopProfile?.page_data?.bio}
                          </h5>
                        </div>
                      </div>
                    </div>

                    <div>
                      <Separator className="my-4" />
                      <h1 className="text-lg font-bold">Facebook</h1>
                      <div className="flex items-center space-x-3 mt-1 mb-3">
                        {userShopProfile?.facebook_link ? (
                          <>
                            <Link to={userShopProfile?.facebook_link} className="text-sm font-semibold">
                              {userShopProfile?.facebook_link}
                            </Link>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>

                    <div>
                      <Separator className="my-4" />
                      <h1 className="text-lg font-bold">Telegram</h1>
                      <div className="flex items-center space-x-3 mt-1 mb-3">
                        {userShopProfile?.telegram_link ? (
                          <>
                            <Link to={userShopProfile?.telegram_link} className="text-sm font-semibold">
                              {userShopProfile?.telegram_link}
                            </Link>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>

                    <div>
                      <Separator className="my-4" />
                      <h1 className="text-lg font-bold">TikTok</h1>
                      <div className="flex items-center space-x-3 mt-1 mb-3">
                        {userShopProfile?.tiktok_link ? (
                          <>
                            <Link to={userShopProfile?.tiktok_link} className="text-sm font-semibold">
                              {userShopProfile?.tiktok_link}
                            </Link>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>

                    <div>
                      <Separator className="my-4" />
                      <h1 className="text-lg font-bold">Youtube</h1>
                      <div className="flex items-center space-x-3 mt-1 mb-3">
                        {userShopProfile?.youtube_link ? (
                          <>
                            <Link to={userShopProfile?.youtube_link} className="text-sm font-semibold">
                              {userShopProfile?.youtube_link}
                            </Link>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>

                    <div>
                      <Separator className="my-4" />
                      <h1 className="text-lg font-bold">FlipFlop</h1>
                      <div className="flex items-center space-x-3 mt-1 mb-3">
                        <div className="relative flex items-center">
                          {isCopied && <span className="absolute top-5 left-0 text-green-500 text-xs">Copied!</span>}

                          <p onClick={setCopied} className="text-sm font-semibold cursor-pointer">
                            {process.env.REACT_APP_URL}/profile?id=
                            {userShopProfile?.id}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div>
                      <Separator className="my-4" />
                      <h1 className="text-lg font-bold">Google Map Link</h1>
                      <div className="flex items-center space-x-3 mt-1 mb-3">
                        {userShopProfile?.current_google_map_link ? (
                          <>
                            <Link to={userShopProfile?.current_google_map_link} className="text-sm font-semibold">
                              {userShopProfile?.current_google_map_link}
                            </Link>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>

                    <div>
                      <Separator className="my-4" />
                      <h1 className="text-lg font-bold">Address</h1>
                      <div className="flex items-center space-x-3 mt-1 mb-3">
                        {userShopProfile?.address ? (
                          <>
                            <p className="text-sm font-semibold">{userShopProfile?.address}</p>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>

                    <div>
                      <Separator className="my-4" />
                      <h1 className="text-lg font-bold">Map Location</h1>
                      <div className="h-[400px] mt-4">
                        <GoogleMapPreview latitude={userShopProfile?.location_latitude} longitude={userShopProfile?.location_longitude} />
                      </div>
                    </div>
                  </div>
                </div>

                <DialogFlipFlopPage
                  isDialogOpen={isDialogOpenFlipFlopPage}
                  setIsDialogOpen={setisDialogOpenFlipFlopPage}
                  onValueChange={(value) => {
                    const updateUserShop = {
                      ...userShopProfile,
                      ...value.user_shop,
                    };
                    dispatch(setUserShopProfile(updateUserShop));
                  }}
                />

                <DialogClickShopProfilePicture
                  isDialogOpen={isDialogClickOpenShopProfilePicture}
                  setIsDialogOpen={setIsDialogClickOpenShopProfilePicture}
                  itemUserProfile={userShopProfile}
                  onValueChange={(value) => {
                    const updateData = {
                      ...userShopProfile,
                      picture: value.picture,
                    };
                    dispatch(setUserShopProfile(updateData));
                  }}
                />

                <DialogClickShopCoverProfile
                  itemCoverProfile={itemCoverProfile}
                  userAllCoverProfiles={userAllCoverProfiles}
                  onValueDelete={(value) => {
                    submitDeleteShopProfileCover(value);
                  }}
                  setIsDialogOpen={setIsDialogClickOpenCoverProfile}
                  isDialogOpen={isDialogClickOpenCoverProfile}
                />
              </Card>
            </div>
          ) : (
            <></>
          )}
        </>
      )}
    </BusinessSuiteContentLayout>
  );
}
